import React from "react";
import { Box } from "@mui/material";
import { ReactComponent as AddUserIcon } from "../assets/icons/dashboard/user/addUserIcon.svg";
import { useTheme } from "@mui/material/styles";

export default function AddButton({ label, onClick }) {
  const theme = useTheme();

  return (
    <Box
      onClick={onClick}
      display="flex"
      gap={1}
      sx={{
        alignItems: "center",
        height: "40px",
        width: "120px",
        border: 1,
        borderRadius: "5px",
        p: 1,
        backgroundColor: theme.palette.buttonHover.main,
        "&:hover": {
          backgroundColor: theme.palette.buttonHover.secondary,
        },
        cursor: "pointer",
      }}
      className="flex justify-center"
    >
      <AddUserIcon
        style={{
          color: theme.palette.white.main,
          fontSize: "16px",
        }}
      />
      <p
        className="font-inter font-semibold"
        style={{ fontSize: "11px", color: theme.palette.white.main }}
      >
        {label}
      </p>
    </Box>
  );
}
